import {ActionTree} from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';

export const actions: ActionTree<any, any> = {

    loadRedemptionApprovals: ({state, getters, commit, dispatch}, force) => {

        if (force) commit('clearCache');

        return new Promise((resolve, reject) => {

            // Pull from store if loaded and cache hasn't expired
            if (state.expires && moment().isBefore(state.expires)) {

                resolve(state.redemptions);

            } else {

                commit('setLoading', true);

                axios.get('/redemptions')

                    .then(({data}) => {
                        commit('setData', data.data);
                        commit('setAvailable', data.available);
                        commit('setLoading', false);
                        resolve(null);
                    })
                    .catch(error => {
                        commit('setLoading', false);
                        reject(error.response);
                    });
            }
        });
    },

    loadRedemptionHistory: ({state, getters, commit, dispatch}, {itemsPerPage, page}) => {

        return new Promise((resolve, reject) => {

            commit('setHistoryLoading', true);

            axios.get('/redemptions/history?itemsPerPage=' + itemsPerPage + '&page='+page)

                .then(({data}) => {

                    commit('setHistory', data.redemptions);
                    commit('setHistoryLoading', false);
                    resolve(null);
                })
                .catch(error => {
                    commit('setHistoryLoading', false);
                    reject(error.response);
                });
        });
    },

    approveRedemptions: ({state, rootState, getters, commit, dispatch}, {ids,history}) => {

        const backup = [...state.redemptions];

        commit('setApproved', {ids: ids, user: rootState.user, approved: true, history: history});

        return new Promise((resolve, reject) => {

            commit('setApproving', true);

            axios.post('/redemptions/approve', ids)

                .then((result) => {
                    commit('setApproving', false);
                    resolve(null);
                })
                .catch(error => {
                    commit('setApproving', false);
                    commit('setData', backup);
                    reject(error.response);
                });
        });
    },

    rejectRedemptions: ({state, rootState, getters, commit, dispatch}, {ids, history}) => {

        const backup = [...state.redemptions];

        commit('setApproved', {ids: ids, user: rootState.user, approved: false, history: history});

        return new Promise((resolve, reject) => {

            commit('setRejecting', true);

            axios.post('/redemptions/reject', ids)

                .then((result) => {
                    commit('setRejecting', false);
                    resolve(null);
                })
                .catch(error => {
                    commit('setRejecting', false);
                    commit('setData', backup);
                    reject(error.response);
                });
        });
    },
};
